import {
  Button,
  Card,
  Checkbox,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  TextField,
} from "@mui/material";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";

import { useMaterialUIController } from "context";
import { getHelpPages } from "controllers/MenuController";
import React, { useEffect, useState } from "react";
import getText from "Translator";
import Swal from "sweetalert2";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { updateAnswersRowNumbers } from "controllers/QuestionController";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { deleteAnswerItem } from "controllers/QuestionController";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { updateAnswerRelated } from "controllers/QuestionController";
let rowsPerPage = 20;
let pageNumber = 1;
const NewAnaswer = (props) => {
  const [answers, setAnswers] = useState([]);
  const [helpPageList, setHelpPageList] = useState([]);
  const [xx, setXx] = useState();
  const [reload, setReload] = useState(new Date());
  const [open, setOpen] = useState(false);

  const [hideAnwers, setHideAnwers] = useState(false);
  const [controller] = useMaterialUIController();
  const {
    capsule,
    qustonType,
    setQuestionAnswers,
    getSubAnswerHandler,
    topAnswer,
    question,
    topAnswerValue,
    handleOpenRelatdAnswer,
  } = props;
  console.log("questionquestionquestionquestionquestion", question);
  const getHelpFormData = async () => {
    try {
      let datas = await getHelpPages(
        controller.lang,
        { capsule },
        controller.token
      );
      setHelpPageList(datas.data);
    } catch (err) {
      console.log(err);
      Swal.fire({
        text: getText("generalerror", controller.lang),
        icon: "warning",
      });
    }
  };

  useEffect(() => {
    getHelpFormData();

    let answerList = [];
    if (props.answerList.length === 0) {
      if (!topAnswer && (qustonType === "FLAT" || qustonType === "FLATB")) {
        answerList = [
          {
            text: "YES",
            value: "101",
            rownumber: 1,
            isNext: false,
            defaultValue: false,
            isBack: false,
            hasHelp: false,
            titleOption1: "",
            titleOption2: "",
            topAnswer: null,
            multiSub: false,
          },
          {
            text: "NO",
            value: "102",
            rownumber: 2,
            isNext: false,
            defaultValue: false,
            isBack: false,
            hasHelp: false,
            titleOption1: "",
            titleOption2: "",
            topAnswer: null,
            multiSub: false,
          },
        ];
        // setAnswers(answerList);

        changeAnswerHandler(0, "text", "Yes", answerList);
      } else {
        console.log("topAnswerValuetopAnswerValue", topAnswerValue);
        //let topAnswerValue= question.answers.filter(a=>)
        answerList = [
          {
            text: "",
            value: topAnswerValue ? topAnswerValue + "01" : "",
            rownumber: 1,
            isNext: false,
            defaultValue: false,
            isBack: false,
            hasHelp: false,
            titleOption1: "",
            titleOption2: "",
            topAnswer: topAnswer,
            multiSub: false,
          },
          {
            text: "",
            value: topAnswerValue ? topAnswerValue + "02" : "",
            rownumber: 2,
            isNext: false,
            defaultValue: false,
            isBack: false,
            hasHelp: false,
            titleOption1: "",
            titleOption2: "",
            topAnswer: topAnswer,
            multiSub: false,
          },
        ];
        setAnswers(answerList);
      }
    } else {
      answerList = props.answerList;
      answerList.map((item) => {
        item["hasHelp"] = true;
        if (!item.help || item.help == "") {
          item["hasHelp"] = false;
        }
      });
      setAnswers(answerList);
    }
  }, [qustonType, props.answerList]);

  const removeAnswerItem = (index) => {
    Swal.fire({
      text: getText("deleteconfirm", controller.lang),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: getText("confirmButtonText", controller.lang),
    }).then(async (result) => {
      if (result.value) {
        let newList = answers;
        if (newList[index].id) {
          let newData = {
            id: newList[index].id,
          };

          let result = await deleteAnswerItem(
            controller.lang,
            newData,
            controller.token
          );
          if (result.success) {
            newList = answers;
            newList.splice(index, 1);
            setAnswers(newList);
            setQuestionAnswers(newList);
            setXx(newList.length);
            Swal.fire({
              text: result.message,
              icon: "success",
              confirmButtonColor: "#3085d6",
              confirmButtonText: getText("ok", controller.lang),
            });
          } else {
            Swal.fire({
              text: result.message,
              icon: "warning",
              confirmButtonColor: "#3085d6",
              confirmButtonText: getText("ok", controller.lang),
            });
          }
        } else {
          newList = answers;
          newList.splice(index, 1);
          setAnswers(newList);
          setQuestionAnswers(newList);
          setXx(newList.length);
          Swal.fire({
            text: result.message,
            icon: "success",
            confirmButtonColor: "#3085d6",
            confirmButtonText: getText("ok", controller.lang),
          });
        }
      }
    });
  };
  const isNumeric = (value) => {
    return /^-?\d+$/.test(value);
  };
  const addNewAnswerItem = () => {
    let newValue = 1;
    answers.map((item) => {
      if (isNumeric(item.value)) {
        if (newValue < Number(item.value)) {
          newValue = Number(item.value);
        }
      }
    });
    newValue = newValue + 1;
    let newItem = {
      text: "",
      value: newValue !== 1 ? newValue : "",
      rownumber: answers.length + 1,
      titleOption1: "",
      titleOption2: "",
      isNext: false,
      defaultValue: false,
      isBack: false,
      topAnswer,
      multiSub: false,
    };
    let newList = answers;
    newList.push(newItem);

    setAnswers(newList);
    setXx(newList.length);
  };
  const changeAnswerHandler = (index, field, value, existanswes) => {
    let ans = existanswes ? existanswes : answers;
    if (field === "text") ans[index].text = value;
    if (field === "value") {
      if (qustonType === "RANGE") {
        ans[index].text = value;
        ans[index].isNext = false;
        ans[index].defaultValue = false;
        ans[index].isBack = false;
        ans[index].titleOption1 = "";
        ans[index].titleOption2 = "";
      }
      ans[index].value = value;
    }

    if (field === "multiSub") ans[index].multiSub = value;
    if (field === "isNext") ans[index].isNext = value;
    if (field === "defaultValue") ans[index].defaultValue = value;
    if (field === "isBack") ans[index].isBack = value;
    if (field === "titleofoption1") ans[index].titleOption1 = value;
    if (field === "titleofoption2") ans[index].titleOption2 = value;
    setAnswers(ans);
    setXx(value);
    setQuestionAnswers(ans);
    setReload(new Date());
  };
  const handleDropRows = (droppedItem) => {
    // Ignore drop outside droppable container
    if (!droppedItem.destination) return;
    var updatedList = [...answers];
    // Remove dragged item
    const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1);
    // Add dropped item
    updatedList.splice(droppedItem.destination.index, 0, reorderedItem);
    // Update State
    updatedList.map((item, index) => {
      item.rownumber = index + 1;
    });
    updateAnswersRowNumbers(controller.lang, updatedList, controller.token);
    setAnswers(updatedList);
  };
  return (
    <>
      <Grid container>
        <Grid
          xs={12}
          md={12}
          item
          style={{
            textAlign: "right",
          }}
        >
          {hideAnwers == false && (
            <KeyboardArrowUpIcon
              style={{ width: 24, fontSize: 24, cursor: "pointer" }}
              onClick={() => {
                setHideAnwers(!hideAnwers);
              }}
            />
          )}
          {hideAnwers == true && (
            <KeyboardArrowDownIcon
              style={{ width: 24, fontSize: 24, cursor: "pointer" }}
              onClick={() => {
                setHideAnwers(!hideAnwers);
              }}
            />
          )}
        </Grid>
      </Grid>
      <DragDropContext
        style={{
          width: "100%",
        }}
        onDragEnd={handleDropRows}
      >
        <Droppable droppableId="list-container">
          {(provided) => (
            <div {...provided.droppableProps} ref={provided.innerRef}>
              {answers.map((item, index) => (
                <Draggable
                  key={index + 100 + "_answer"}
                  draggableId={index + 100 + ""}
                  index={index}
                >
                  {(provided) => (
                    <div
                    // style={{
                    //   marginBottom: 5,
                    //   height: hideAnwers ? 35 : "unser",
                    //   overflow: "hidden",
                    // }}
                    >
                      <fieldset
                        ref={provided.innerRef}
                        {...provided.dragHandleProps}
                        {...provided.draggableProps}
                      >
                        <legend>{`${index + 1} ( ${item.text} ) `}</legend>

                        <Grid
                          container
                          key={index + ""}
                          style={{
                            display: hideAnwers && item.id ? "none" : "unset",
                          }}
                        >
                          {(qustonType === "CHECKED" ||
                            qustonType === "MRD") && (
                            <Grid
                              xs={12}
                              sm={12}
                              md={12}
                              style={{ marginTop: 15 }}
                            >
                              {/* <div
                            style={{
                              fontSize: 13,
                              fontWeight: "bold",
                              color: "#BD4941",
                            }}
                          >
                            {getText("titleoption", controller.lang) }
                          </div> */}
                              <TextField
                                id={"titleofoption" + index}
                                variant="outlined"
                                label={getText("titleoption", controller.lang)}
                                fullWidth={true}
                                value={item.titleOption1}
                                onChange={(event) => {
                                  changeAnswerHandler(
                                    index,
                                    "titleofoption1",
                                    event.target.value
                                  );
                                }}
                              />
                            </Grid>
                          )}

                          {qustonType != "RANGE" && (
                            <Grid
                              xs={12}
                              sm={12}
                              md={12}
                              style={{ marginTop: 15 }}
                            >
                              {/* <div
                            style={{
                              fontSize: 13,
                              fontWeight: "bold",
                              color: "#BD4941",
                            }}
                          >
                            {getText("text", controller.lang) +
                              " " +
                              (index + 1)}
                          </div> */}
                              <TextField
                                id={"text" + index}
                                variant="outlined"
                                label={getText("text", controller.lang)}
                                fullWidth={true}
                                value={item.text}
                                onChange={(event) => {
                                  changeAnswerHandler(
                                    index,
                                    "text",
                                    event.target.value
                                  );
                                }}
                              />
                            </Grid>
                          )}
                          <Grid container style={{ marginTop: 5 }}>
                            <Grid
                              xs={4}
                              sm={4}
                              md={4}
                              style={{ marginTop: 15, paddingBlockEnd: 10 }}
                            >
                              {/* <div
                          style={{
                            fontSize: 13,
                            fontWeight: "bold",
                            color: "#BD4941",
                          }}
                        >
                          {qustonType === "RANGE"
                            ? getText(
                                index == 0 ? "start" : "end",
                                controller.lang
                              )
                            : "Value " + (index + 1)}{" "}
                        </div> */}
                              <TextField
                                id={"value" + index}
                                variant="outlined"
                                label={
                                  qustonType === "RANGE"
                                    ? getText(
                                        index == 0 ? "start" : "end",
                                        controller.lang
                                      )
                                    : "Value " + (index + 1)
                                }
                                fullWidth={true}
                                value={item.value}
                                type={qustonType === "RANGE" ? "number" : ""}
                                onChange={(event) => {
                                  changeAnswerHandler(
                                    index,
                                    "value",
                                    event.target.value
                                  );
                                }}
                              />
                            </Grid>
                            {(qustonType == "FLAT" ||
                              qustonType === "FLATB") && (
                              <Grid
                                item
                                xs={6}
                                sm={6}
                                md={6}
                                style={{ marginTop: 20 }}
                              >
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={item.defaultValue}
                                      onChange={() => {
                                        if (!item.defaultValue) {
                                          answers.map((ii, ind) => {
                                            changeAnswerHandler(
                                              ind,
                                              "defaultValue",
                                              false
                                            );
                                          });
                                        }
                                        changeAnswerHandler(
                                          index,
                                          "defaultValue",
                                          !item.defaultValue
                                        );
                                      }}
                                      name="defaultValue"
                                    />
                                  }
                                  label={getText(
                                    "defaultvalue",
                                    controller.lang
                                  )}
                                />
                              </Grid>
                            )}
                            {qustonType != "RANGE" && (
                              <Grid
                                item
                                xs={6}
                                sm={6}
                                md={6}
                                style={{ marginTop: 20 }}
                              >
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={item.isNext}
                                      onChange={() => {
                                        if (
                                          item.isNext == false &&
                                          item.isBack == true
                                        ) {
                                          changeAnswerHandler(
                                            index,
                                            "isBack",
                                            false
                                          );
                                        }
                                        changeAnswerHandler(
                                          index,
                                          "isNext",
                                          !item.isNext
                                        );
                                      }}
                                      name="isNext"
                                    />
                                  }
                                  label={getText("gonextpage", controller.lang)}
                                />
                              </Grid>
                            )}
                            {qustonType != "RANGE" && (
                              <Grid
                                item
                                xs={6}
                                sm={6}
                                md={6}
                                style={{ marginTop: 20 }}
                              >
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={item.isBack}
                                      onChange={() => {
                                        if (
                                          item.isBack == false &&
                                          item.isNext == true
                                        ) {
                                          changeAnswerHandler(
                                            index,
                                            "isNext",
                                            false
                                          );
                                        }
                                        changeAnswerHandler(
                                          index,
                                          "isBack",
                                          !item.isBack
                                        );
                                      }}
                                      name="isBack"
                                    />
                                  }
                                  label={getText("gobackpage", controller.lang)}
                                />
                              </Grid>
                            )}
                            {qustonType === "FLATB" && (
                              <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                style={{ marginTop: 20 }}
                              >
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={item.multiSub}
                                      onChange={() => {
                                        changeAnswerHandler(
                                          index,
                                          "multiSub",
                                          !item.multiSub
                                        );
                                      }}
                                      name="multisub"
                                    />
                                  }
                                  label={getText("multisub", controller.lang)}
                                />
                              </Grid>
                            )}
                          </Grid>

                          {(qustonType === "CHECKED" ||
                            qustonType === "MRD") && (
                            <Grid
                              xs={12}
                              sm={12}
                              md={12}
                              style={{ marginTop: 15 }}
                            >
                              {/* <div
                            style={{
                              fontSize: 13,
                              fontWeight: "bold",
                              color: "#BD4941",
                            }}
                          >
                            {getText("titleoption", controller.lang) + " " + 2}
                          </div> */}
                              {/* <TextField
                                id={"titleofoption2" + index}
                                variant="outlined"
                                label={getText("titleoption", controller.lang)}
                                fullWidth={true}
                                value={item.titleOption2}
                                onChange={(event) => {
                                  changeAnswerHandler(
                                    index,
                                    "titleofoption2",
                                    event.target.value
                                  );
                                }}
                              /> */}
                            </Grid>
                          )}

                          <Grid
                            xs={12}
                            sm={12}
                            md={12}
                            style={{
                              marginTop: 15,
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                            }}
                          >
                            {answers.length > 2 && (
                              <Button
                                onClick={() => removeAnswerItem(index)}
                                fullWidth={true}
                                color="secondary"
                                startIcon={<HighlightOffIcon />}
                              >
                                {getText("delete", controller.lang)}
                              </Button>
                            )}
                            {(qustonType === "FLAT" ||
                              qustonType === "FLATB") &&
                              item.id && (
                                <Button
                                  onClick={() => getSubAnswerHandler(item.id)}
                                  fullWidth={true}
                                  color="secondary"
                                  startIcon={<AddCircleOutlineIcon />}
                                >
                                  {getText("addsubanswer", controller.lang)}
                                </Button>
                              )}
                          </Grid>
                        </Grid>
                      </fieldset>
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
              {qustonType !== "RANGE" && (
                <Button
                  fullWidth={true}
                  color="primary"
                  onClick={addNewAnswerItem}
                >
                  {getText("addnewitem", controller.lang)}
                </Button>
              )}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </>
  );
};
export default NewAnaswer;
